import { render, staticRenderFns } from "./SentSummary.vue?vue&type=template&id=e396a66a&scoped=true&"
import script from "./SentSummary.vue?vue&type=script&lang=js&"
export * from "./SentSummary.vue?vue&type=script&lang=js&"
import style0 from "./SentSummary.vue?vue&type=style&index=0&id=e396a66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e396a66a",
  null
  
)

export default component.exports